import api from './api';

/**
 * GET /course passou a devolver { courses, groupCourses }.
 * Aceita também o array legado.
 */
export function unwrapCourseCatalog(data) {
    if (Array.isArray(data)) {
        return {
            courses: data,
            groupCourses: [],
            coursesTotal: data.length,
            groupCoursesTotal: 0,
            page: 0,
            size: data.length,
            simpleCoursesCount: data.length,
            modulesTotal: 0,
            lessonsTotal: 0,
        };
    }
    if (!data || typeof data !== 'object') {
        return {
            courses: [],
            groupCourses: [],
            coursesTotal: 0,
            groupCoursesTotal: 0,
            page: 0,
            size: 0,
            simpleCoursesCount: 0,
            modulesTotal: 0,
            lessonsTotal: 0,
        };
    }
    const courses = Array.isArray(data.courses) ? data.courses : [];
    const groupCourses = Array.isArray(data.groupCourses) ? data.groupCourses : [];
    return {
        courses,
        groupCourses,
        coursesTotal: data.coursesTotal ?? courses.length,
        groupCoursesTotal: data.groupCoursesTotal ?? groupCourses.length,
        page: data.page ?? 0,
        size: data.size ?? courses.length + groupCourses.length,
        simpleCoursesCount: data.simpleCoursesCount ?? data.coursesTotal ?? courses.length,
        modulesTotal: data.modulesTotal ?? 0,
        lessonsTotal: data.lessonsTotal ?? 0,
    };
}

export function unwrapCoursesList(data) {
    return unwrapCourseCatalog(data).courses;
}

export function encodeImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    const trimmed = url.trim();
    if (!trimmed) return '';
    try {
        if (/^https?:\/\//i.test(trimmed)) {
            return new URL(trimmed).href;
        }
        return encodeURI(trimmed);
    } catch (e) {
        try {
            return encodeURI(trimmed);
        } catch (e2) {
            return trimmed;
        }
    }
}

/** Capa do card: thumb (path2) → capa (path) → imageUrl. */
export function courseCoverSrc(item, fallback = '') {
    if (!item || typeof item !== 'object') return fallback;
    const raw = [
        item.imageFinalPath2,
        item.imageFinalPath,
        item.imageUrl,
        item.imagePath,
    ].find((value) => typeof value === 'string' && value.trim() !== '');
    if (!raw) return fallback;
    return encodeImageUrl(raw) || fallback;
}

/** Cursos simples + grupos (produtos vendáveis, ex. cupons). */
export function unwrapSellableCatalog(data) {
    const catalog = unwrapCourseCatalog(data);
    const courses = Array.isArray(catalog.courses) ? catalog.courses : [];
    const groupCourses = Array.isArray(catalog.groupCourses) ? catalog.groupCourses : [];
    return [...courses, ...groupCourses].map((item) => {
        const isGroup = Number(item.type) === 2
            || item.mode === 'group'
            || item.mode === 'path'
            || Array.isArray(item.courseIds);
        const name = item.comercialName || item.commercialName || item.name || '';
        const imageFinalPath = encodeImageUrl(
            item.imageFinalPath || item.imageUrl || item.imagePath || '',
        );
        const imageFinalPath2 = encodeImageUrl(item.imageFinalPath2 || '') || imageFinalPath;
        return {
            ...item,
            type: isGroup ? 2 : (item.type || 1),
            comercialName: name,
            couponLabel: isGroup ? `Grupo: ${name}` : `Curso: ${name}`,
            price: item.price || 0,
            discount: item.discount || 0,
            imageFinalPath,
            imageFinalPath2,
        };
    });
}

export default {
    async getDataCourse(accessToken, params = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get('/course', {
                method: 'GET',
                headers,
                params: {
                    ...params,
                },
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            throw error;
        }
    },
    
    async createNewCourse(userData, accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/course', userData, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados da criação do curso:', error);
            throw error;
        }
    },

    async getCourse(id, accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/course/${id}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados da criação do curso:', error);
            throw error;
        }
    },

    async editCourse(id, payload, accessToken){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.put(`/course/${id}`, payload ,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter editar o curso:', error);
            throw error;
        }
    },
    async getCourseTypeCount(accessToken, id){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`course/${id}/type-count` ,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter contadores do curso:', error);
            throw error;
        }
    },
    async manualEnrol(accessToken, payload){
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/enrol/manual`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao matricular aluno:', error);
            throw error;
        }
    }
}

